import { render, staticRenderFns } from "./OnboardingSlides.vue?vue&type=template&id=326f33c1&scoped=true&"
import script from "./OnboardingSlides.vue?vue&type=script&lang=js&"
export * from "./OnboardingSlides.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSlides.vue?vue&type=style&index=0&id=326f33c1&prod&lang=scss&scoped=true&"
import style1 from "./OnboardingSlides.vue?vue&type=style&index=1&id=326f33c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326f33c1",
  null
  
)

export default component.exports